<template>
    <div class="app__page">
        <mobile-menu />
        <div class="page__wrapper" ref="pageWrapper">
            <div class="header">
                <i @click="toggleMenu()" class="far fa-bars" id="menu-icon"></i>
                <img class="header__logo" src="static/logo.png"/>
            </div>
            <crumbs />
            <div class="content-area">
                <transition
                enter-active-class="slide-tray--animate-active"
                leave-active-class="slide-tray--animate-active"
                :enter-class="css_enter"
                :leave-to-class="css_leave"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="footer-area">
                <router-view name="footer"/>
            </div>
        </div>
        <div class="privacy-popover">
            <p><a href="http://www.rangemaster.co.uk/privacy-security" target="_blank">Privacy &amp; Security</a></p>
        </div>
    </div>
</template>

<script>
import MobileMenu from '../ui/mobile-menu.vue';
import Crumbs from '../ui/crumbs.vue';

export default {
    data: function(){ 
        return {
        css_enter: 'slide-tray--animate-right',
        css_leave: 'slide-tray--animate-left'
        };
    },
    watch: {
        '$route'(to, from) {
            if ( document.querySelector(".push__menu").classList.contains("open") ){
                this.css_enter = null;
                this.css_leave = null;
            } else if (to.meta.step > from.meta.step) {
                //normal animation
                this.css_enter = 'slide-tray--animate-right';
                this.css_leave = 'slide-tray--animate-left';
            } else {
                //reverse animation
                this.css_enter = 'slide-tray--animate-left';
                this.css_leave = 'slide-tray--animate-right';
            }

        }
    },
    components: {
        crumbs: Crumbs,
        mobileMenu: MobileMenu
    },
    methods: {
        go(name){
            this.$router.push({ name })
        },
        toggleMenu(){
            document.querySelector(".push__menu").classList.toggle("open");
        }
    }
}
</script>

<style lang="scss">


.slide-tray--animate-active {
    transition: all 0.4s;
    position: absolute; //ONLY WHEN SLIDING IN.
    top:0;
    left:0;
    right:0;
    bottom:0;
}

.slide-tray--animate-right {
    transform: translateX(100%);
}

.slide-tray--animate-left {
    transform: translateX(-100%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page-search.vue